import { useRouter } from '@hozana/router'

import { getAdminRoutes } from 'routes/constants'

export const useAdminRoutes = () => {
  const router = useRouter()

  return getAdminRoutes(router.locale)
}
